import {
  createSlice,
  createAsyncThunk,
  PayloadAction,
  CaseReducer,
} from '@reduxjs/toolkit';
import { DataLogs, Log, ParamsGetLogs } from '../models/log';

import logService from '../services/log';
import { RequestLoading } from '@app/utils/constants';
import { handleErrorResponse } from '@app/utils/helpers';

const requests = ['getLogs'] as const;

type LogRequest = RequestLoading<(typeof requests)[number]>;

interface State {
  dataLogs: DataLogs;
  getLogLoading: boolean;
  selectedLog: Log | undefined;
  logRequest: LogRequest;
}

const initialState: State = {
  dataLogs: {
    data: [],
    paging: undefined,
  },
  getLogLoading: false,
  selectedLog: undefined,
  logRequest: {
    loading: false,
  },
};

type CR<T> = CaseReducer<State, PayloadAction<T>>;

const TYPE_REFIX = 'admin/management-log/log/';

const getLogs = createAsyncThunk<DataLogs, ParamsGetLogs>(
  TYPE_REFIX + 'getLog',
  async (params, { rejectWithValue }) => {
    try {
      const result = await logService.getLogs(params);
      return result;
    } catch (error) {
      return rejectWithValue(handleErrorResponse(error));
    }
  },
);

const slice = createSlice({
  name: 'admin/management-customer/customer',
  initialState,
  reducers: {
    setSelectedLog: (state, action) => {
      // state.selectedLog = action.payload;
    },
  },
  extraReducers: (builder) => {
    //getLog
    builder.addCase(getLogs.pending, (state, action) => ({
      ...state,
      // getLogLoading: true,
      logRequest: {
        loading: true,
        name: 'getLogs',
        status: action.meta.requestStatus,
      },
    }));
    builder.addCase(getLogs.fulfilled, (state, action) => ({
      ...state,
      // dataTable: payload,
      // getLogLoading: false,
      logRequest: {
        loading: false,
        name: 'getLogs',
        status: action.meta.requestStatus,
      },
      dataLogs: action.payload,
    }));
    builder.addCase(getLogs.rejected, (state, action) => ({
      ...state,
      // getLogLoading: false,
      logRequest: {
        loading: false,
        name: 'getLogs',
        status: action.meta.requestStatus,
        error: action.payload ?? action.error,
      },
    }));
  },
});

export const { setSelectedLog } = slice.actions;

export { getLogs };

export default slice.reducer;
